



































import { Component, Prop, Watch } from "vue-property-decorator";
import {
  ContaCorrenteParceiro,
  ContaCorrenteParceirosService,
} from "@/services/conta-corrente-parceiros.service";
import { dateTime, moeda } from "@/shared/filters";
import Tooltip from "@/shared/components/tooltip.vue";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import Detalhes from "./Detalhes.vue";
import Saque from "./Saque.vue";
import { mixins } from "vue-class-component";
@Component({
  components: { Tooltip, DataTable, Detalhes, Saque },
  filters: { dateTime, moeda },
})
export default class ContaCorrenteParceiros extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  ccParceiro: Promise<ContaCorrenteParceiro[]> | null = null;

  headers = [
    { value: "descricao", text: "Descrição" },
    { value: "data", text: "Data" },
    { value: "saldoAnterior", text: "Saldo Anterior" },
    { value: "valor", text: "Valor Registro" },
    { value: "saldoAtual", text: "Saldo Atual" },
  ];
  mounted() {
    this.fetchHistoricos();
  }
  async fetchHistoricos() {
    this.ccParceiro = ContaCorrenteParceirosService.listarContaCorrenteParceiro(
      this.idConsultor
    );
  }
  async realizarSaque() {
    const modal = this.$refs.saque as Saque;
    await modal.efetuarSaque(this.idConsultor);
    this.fetchHistoricos();
  }
  @Watch("idConsultor")
  changeProduto() {
    this.fetchHistoricos();
  }
}
